export const RESET_REDUX = '@catholic-web/logout/triggerLogout';

export const resetState = () => ({
    type: RESET_REDUX,
});
